import { Button } from '@mui/material';

import { ActionsPopover } from 'components/popovers/actions-popover';

import { usePopover } from 'components/popovers/popover-wrapper/usePopover';

import { ReactComponent as EditPlanIcon } from 'assets/icons/edit-icon.svg';

import { popperStyles } from 'components/popovers/actions-popover/styles';

import { PaymentPlan } from 'utils/types';

interface IProps {
  plan: PaymentPlan;
  onEditPlan: (plan: PaymentPlan) => void;
}

export const PlanTableActionsPopper = ({ plan, onEditPlan }: IProps) => {
  const { anchorEl, handleOpen, handleClose, open } = usePopover();

  const handleEdit = () => {
    onEditPlan(plan);
    handleClose();
  };

  return (
    <ActionsPopover
      anchorEl={anchorEl}
      open={open}
      handleClose={handleClose}
      handleOpen={handleOpen}
    >
      <Button sx={popperStyles.actionBtn} startIcon={<EditPlanIcon />} onClick={handleEdit}>
        edit plan
      </Button>
    </ActionsPopover>
  );
};
